import { render, staticRenderFns } from "./ModelManager.vue?vue&type=template&id=e7bbcc48&"
import script from "./ModelManager.vue?vue&type=script&lang=ts&"
export * from "./ModelManager.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports